/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { gql } from '@apollo/client';
export type CmExternalLinkFragment = { __typename?: 'CMExternalLinkImpl', id: string, type: string, selfUrl?: string | null, canonicalUrl?: string | null, robots?: boolean | null, title?: string | null, teaserTitle?: string | null, url?: string | null, openInNewTab?: boolean | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null } | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null } | null };

export const CmExternalLinkFragmentDoc = gql`
    fragment CMExternalLink on CMExternalLink {
  id
  type
  selfUrl
  canonicalUrl
  robots
  title
  detailText {
    textAsTree
  }
  teaserTitle
  teaserText {
    textAsTree
  }
  url
  openInNewTab
}
    `;